/* istanbul ignore file */

import {
  Box,
  Checkbox as Checkbox_,
  Radio as Radio_,
} from "@vinomofo/components";

import * as React from "react";
import styled from "styled-components";

type FilterOptionProps = {
  label: string;
  type: "radio" | "checkbox";
  selected: boolean;
  disabled?: boolean;
  count?: number;
  onChange: (event: MouseEvent | React.ChangeEvent<HTMLInputElement>) => void;
};

const FilterOption = ({
  label,
  type,
  selected = false,
  disabled = false,
  count,
  onChange,
}: FilterOptionProps): JSX.Element => {
  const generateLabel = (label: string, count: number) => {
    return count ? (
      <>
        {label} <Count>({count})</Count>
      </>
    ) : (
      label
    );
  };

  return (
    <Option onClick={onChange} disabled={disabled}>
      {"radio" === type ? (
        <>
          <Radio_
            checked={selected}
            value={label}
            name={label}
            className="radio-btn"
          />
          <Box display="flex" alignItems="center">
            <Label
              color={disabled ? "disabled" : "heading"}
              opacity={disabled ? 0.5 : 1}
            >
              {label}
            </Label>
            {count && <Count>({count})</Count>}
          </Box>
        </>
      ) : (
        <Checkbox_
          checked={selected}
          label={generateLabel(label, count)}
          onChange={() => {}}
        />
      )}
    </Option>
  );
};

const Option = styled.button`
  border: 0;
  padding: 6px 0;
  outline: 0;
  background: none;
  appearance: none;
  display: flex;
  align-items: center;
  width: 100%;
  color: ${({ theme }) => theme.colors.text.heading};
  text-align: left;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.text.heading};
    opacity: 0.5;
    cursor: not-allowed;
  }

  .radio-btn {
    height: 25px;
    width: 25px;
    margin-right: 10px;
  }
`;

const Label = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: inherit;
  letter-spacing: -0.31px;
  margin-right: 6px;
  line-height: 1;
`;

const Count = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.normal};
  line-height: 1;
`;

export default FilterOption;
